import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { trackContact } from '../utils/pixel';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const whatsappLink = `https://wa.me/19548223252?text=${encodeURIComponent(t('wa.hero'))}`;
  return <section className="py-14 md:py-20 bg-[#111111] text-white border-t border-white/5" data-id="element-36">
      <div className="container mx-auto px-5 md:px-6 text-center" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-38">
          <h2 className="text-2xl md:text-4xl font-black mb-2 uppercase tracking-tight" data-id="element-39">
            {t('final.title')}
          </h2>
          <p className="text-white/40 text-sm md:text-base mb-6 md:mb-8" data-id="element-40">
            {t('final.sub')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-41">
            <button onClick={scrollToForm} data-track-cta="final-cta" className="w-full sm:w-auto btn-primary py-3.5 px-8 md:py-4 md:px-10 rounded-md text-sm md:text-base" data-id="element-42">
              {t('final.cta')}
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}